<template>
  <div>
    <ul class="divide-y border rounded-md overflow-hidden">
      <li v-for="item in items" :key="item.title">
        <div
          v-if="!item.link"
          class="text-sm font-bold text-neutral-500 px-3 py-2 uppercase"
        >
          <p>{{ item.label }}</p>
        </div>
        <div 
          v-else
          :class="[
            'flex items-center gap-3 px-3 py-2 group',
            getStateClasses(item.state).container,
          ]"
          @click="handleItemClick(item)"
        >
          <Icon
            :icon="getStateClasses(item.state).icon"
            :class="['flex-shrink-0', getStateClasses(item.state).iconClass]" 
            height="22"
          />

          <p class="flex-grow line-clamp-1">{{ item.label }}</p>
          <span v-if="item.isPremium" class="inline-flex items-center px-2 py-0.5 text-xs font-semibold bg-amber-100 text-amber-800 rounded">
            Premium
          </span>

          <Icon
            v-if="item.state !== 'disabled'"
            icon="bx:chevron-right"
            class="flex-shrink-0 text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity" 
            height="25"
          />
        </div>
      </li>
    </ul>
    
    <MobPaymentModal ref="mobPaymentModal" />
  </div>
</template>

<script>
import MobPaymentModal from "../payment-premium/PaymentModal.vue";
import { Icon } from "@iconify/vue2";

export default {
  name: "MobList",
  components: {
    Icon,
    MobPaymentModal
  },
  props: {
    items: Array,
  },
  data() {
    return {
      isChecked: false,
    };
  },
  computed: {
    isPremiumUser() {
      return this.$store.state.auth.isPremium;
    },
  },
  methods: {
    handleItemClick(item) {
      if (item.isPremium && !this.isPremiumUser) {
        this.$refs["mobPaymentModal"].showModalPayment();
      } else {
        this.$router.push(item.link);
      }
    },
    getStateClasses(itemState) {
      switch (itemState) {
        case "disabled":
          return {
            icon: "prime:lock",
            iconClass: "",
            container: "bg-neutral-100 text-neutral-400 cursor-not-allowed",
          };

        case "completed":
          return {
            icon: "bx:check",
            iconClass: "text-green-600 rounded-full bg-green-50",
            container: "bg-white text-neutral-500 hover:text-neutral-700 cursor-pointer",
          };

        default:
          return {
            icon: "iconamoon:eye-light",
            iconClass: "",
            container: "bg-white text-neutral-500 hover:text-neutral-700 cursor-pointer",
          };
      }
    },
  },
};
</script>
